import React, {Component} from 'react';
import styles from './DropdownTiny.css';
import Svg from "../Svg/Svg"
import {colorInverter} from "../../services/service-color-inverter"
import {getRandomId} from "../../services/service-utils"
import PropTypes from "prop-types"
import {Icon} from "../../constants/consts-types"
import {TypeColors} from "../../constants/consts-prop-types"

class DropdownTiny extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    ariaLabel: PropTypes.string,
    colors: TypeColors,
    children: PropTypes.any
  }

  constructor(props) {
    super(props)

    this.state = {
      checked: false,
      label: props.label
    }

    this.uniqueId = getRandomId()
    this.onBodyClick = this.onBodyClick.bind(this)
    this.onCheckClick = this.onCheckClick.bind(this)
  }

  componentDidMount() {
    document.body.addEventListener("click", this.onBodyClick);
    // document.body.addEventListener('touchstart', this.onBodyClick)
  }

  componentWillUnmount() {
    document.body.removeEventListener("click", this.onBodyClick);
    // document.body.removeEventListener('touchstart', this.onBodyClick)
  }

  onBodyClick(event) {
    if (event.target !== this.checkbox) {
      if (!this.checkbox) return;

      this.setState({
        checked: false,
      });
    }
  }

  onCheckClick() {
    this.props.setShowOpeningHours(false);
    this.setState(prevState => ({
      checked: !prevState.checked
    }));
  }

  render() {
    const { checked, label } = this.state;

    const { colors, ariaLabel, children, className } = this.props;

    // this.styleInverted = colorInverter(colors)

    const dropdownTinyClassName = [
      checked ? styles.DropdownTinyChecked : styles.DropdownTiny,
      className ? className : "",
    ].join(" ");

    return (
      <div className={dropdownTinyClassName}>
        <input
          ref={(node) => (this.checkbox = node)}
          aria-label={ariaLabel}
          type="checkbox"
          id={this.uniqueId}
          onClick={this.onCheckClick}
          onChange={() => {}}
          className={styles.checkbox}
          checked={checked}
        />
        <label htmlFor={this.uniqueId} className={styles.label}>
          <div className={styles["label-text"]}>{label}</div>
          <div className={[styles.icon, styles["label-icon"]].join(" ")}>
            <Svg id={Icon.DROPDOWN_TINY} />
            <Svg id={Icon.DROPDOWN_TINY_ARROW} className={styles.iconArrow} />
          </div>
        </label>
        {/* <div className={styles.content} style={this.styleInverted}> */}
        <div className={styles.content}>{children}</div>
      </div>
    );
  }
}

export default DropdownTiny;



// WEBPACK FOOTER //
// ./src/components/DropdownTiny/DropdownTiny.js